<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="#00ACC1">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-row>
      <v-col cols="12">
        <v-card flat>
          <v-row justify="end">
            <v-col cols="12" md="3">
              <v-text-field
                dense
                single-line
                hide-details
                color="#00ACC1"
                placeholder="Cari . . ."
                append-icon="mdi-magnify"
                clearable
                :loading="process.load"
                v-model="search.name"
                @click:clear="search.name = ''; fetch();"
                v-on:keyup.enter="fetch()">
              </v-text-field>
            </v-col>
          </v-row>

          <gmap-map
            ref="gmap"
            :center="center"
            :zoom="12"
            :scrollwheel="false"
            style="width:100%; height: calc(100vh - 195px);">
    
            <gmap-marker
              v-for="(item, index) in list.markers"
              :key="index"
              :position="item.latlng"
              :icon="item.icon"
              @click="toggleInfoWindow(item, index)">
            </gmap-marker>

            <gmap-info-window
              :options="infoOptions"
              :position="infoWindowPos"
              :opened="infoWinOpen"
              @closeclick="infoWinOpen=false">
              <div v-html="infoContent"></div>
            </gmap-info-window>
          </gmap-map>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";
  import firebase from "firebase";
  import moment from 'moment';
  export default {
    data () {
      return {
        dialog: {
          snackbar: false
        },
        dateNow: moment().format('YYYY-MM-DD'),
        search: {
          name: ''
        },
        selected: {
          all: []
        },
        center: {
          lat: -7.7400, 
          lng: 110.6646
        },
        infoContent: '',
        infoWindowPos: {
          lat: 0,
          lng: 0
        },
        infoWinOpen: false,
        currentMidx: null,
        infoOptions: {
          pixelOffset: {
            width: 15,
            height: -10
          }
        },
        list: {
          data: [],
          markers: []
        },
        pagination: {
          data: {}
        },
        process: {
          load: false
        },
        message: {
          error: '',
          success: ''
        }
      }
    },
    components: {
      
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      }
    },
    watch: {
      
    },
    created() {
      let ref = firebase.firestore().collection('users')
      ref.onSnapshot(snapshot => {
        this.fetch()
      })
    },
    mounted () {
      
    },
    methods: {
      async fetch() {
        this.process.load = true
        
        let params = {
          limit: 1000000,
          'date[gte]': this.dateNow,
          end_bool: false,
          search: this.search.name
        }

        this.selected.all = []
        this.list.markers = []

        await get(`admin/attended`, { params }).then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.list.data = res.results.data
            this.pagination.data = res.results.pagination
            
            if (this.pagination.data.total_data > 0) {
              this.list.data.map((obj) => {
                this.selected.all.push(obj)
              })

              this.fetchCheck()
            } else {
              // this.selected.all = []
              // this.list.markers = []

              this.dialog.snackbar = this.search.name.length > 0 ? true : false
              this.message.success = this.search.name.length > 0 ? 'Data yang anda cari tidak ditemukan.' : ''
            }
          }
        })
      },
      async fetchCheck() {
        let data = this.selected.all
        for (let i = 0; i < data.length; i++) {
          let ref = firebase.firestore().collection('users').where('id', '==', data[i].user_id)
          await ref.onSnapshot(snapshot => {
            if (snapshot.docChanges().length > 0) {
              if (snapshot.docChanges()[0].type === 'added') {
                let id = snapshot.docs.map((doc) => {
                  return doc.id
                })

                this.fetchUser(id[0])
              } else {
                this.list.markers = []

                this.fetch()
              }
            }
          })
        }
      },
      async fetchUser(id) {
        await firebase.firestore().collection('users').doc(id).get()
        .then(snapshot => {
          this.fetchRoute(snapshot.data(), id)
        })
      },
      async fetchRoute(item_user, id) {
        let ref = firebase.firestore().collection('users').doc(id).collection('routes').orderBy('input_datetime', 'asc')
        await ref.onSnapshot(snapshot => {
          if (snapshot.docChanges().length > 0) {
            let data = snapshot.docs.map((doc) => {
              return {
                id: item_user.id,
                name: item_user.name,
                username: item_user.username,
                email: item_user.email,
                mobilephone: item_user.mobilephone,
                role: item_user.role,
                position: item_user.position,
                address: item_user.address,
                image_url: item_user.image_url !== '' ? item_user.image_url : require('@/assets/image/member-default.jpg'),
                lat: doc.data().latitude,
                lng: doc.data().longitude
              }
            })

            this.insertMarker(data)
          } else {
            this.list.markers = []
          }
        })
      },
      insertMarker(data) {
        this.$gmapApiPromiseLazy().then(() => {
          this.list.markers.push({
            id: data[data.length - 1].id,
            name: data[data.length - 1].name,
            username: data[data.length - 1].username,
            email: data[data.length - 1].email,
            mobilephone: data[data.length - 1].mobilephone,
            role: data[data.length - 1].role,
            position: data[data.length - 1].position,
            address: data[data.length - 1].address,
            image_url: data[data.length - 1].image_url,
            latlng: {
              lat: parseFloat(data[data.length - 1].lat), 
              lng: parseFloat(data[data.length - 1].lng)
            },
            icon: {
              url: require('@/assets/image/marker.png'),
              scaledSize: new google.maps.Size(50, 50),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(10, 10)
            }
          })
        })

        this.center = this.list.markers.length > 0 ? this.list.markers[0].latlng : this.center
      },
      toggleInfoWindow(marker, idx) {
        this.infoWindowPos = marker.latlng
        this.infoContent = this.getInfoWindowContent(marker)
        
        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen
        } else {
          this.infoWinOpen = true
          this.currentMidx = idx
        }
      },
      getInfoWindowContent(marker) {
        let data = marker

        return (`
          <div id="iw-container">
            <div class="iw-title">
              Lokasi Terakhir
            </div>

            <div class="iw-content">
              <img 
                class="image"
                height="100" 
                width="100"
                src="${data.image_url}">

              <div class="iw-subTitle">
                ${data.name}
              </div>

              <p style="margin-bottom: 2px; opacity: 50%;">
                Email
              </p>

              <p style="margin-bottom: 6px; font-weight: bold;">
                ${data.email}
              </p>

              <p style="margin-bottom: 2px; opacity: 50%;">
                Telepon
              </p>

              <p style="margin-bottom: 6px; font-weight: bold;">
                ${data.mobilephone}
              </p>

              <p style="margin-bottom: 2px; opacity: 50%;">
                Role (Posisi)
              </p>

              <p style="margin-bottom: 12px; font-weight: bold; text-transform: capitalize;">
                ${data.role} (${data.position})
              </p>

              <p style="margin-bottom: 2px; font-weight: bold;">
                <a href="/user/${data.id}" target="_blank">
                  Lihat Detail . . .
                </a>
              </p>
            </div>
          </div>
        `)
      }
    }
  }
</script>